<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c3.48,0,5.22,1.74,5.22,1.74v13.04L0.5,802.5l-5.22-5.22v-13.04C-4.72,784.24-2.98,782.5,0.5,782.5L0.5,782.5z
	 M-0.78,789.44l-2.86,0.42l2.07,2.02l-0.49,2.84l2.56-1.34l2.56,1.34l-0.49-2.84l2.07-2.02l-2.86-0.42l-1.28-2.59L-0.78,789.44z"/>
</svg>

</template>